import * as API from 'common/constant/routes'
import { getJson, postJson } from 'helper/http'

export const isLoggedIn = () => getJson(API.IS_LOGGED_IN)

export const login = (loginDetails) => postJson(API.AUTH_LOGIN, {}, loginDetails)

export const qlikAuth = (loginDetails) => postJson(API.QLIK_AUTH, {}, loginDetails)

export const logout = () => getJson(API.AUTH_LOGOUT)

export const handoffToken = (siteUuid) => postJson(API.HANDOFF_TOKEN, {}, { site_uuid: siteUuid })
